import { MonitoringService } from '@lockton-apps/shared/util/app-monitoring';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';

import { ErrorInterceptor } from './error.interceptor';
import { ErrorService } from './error.service';
import { GlobalErrorHandler } from './global-error-handler';

export function provideErrorHandling() {
  return [
    ErrorService,
    MonitoringService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ];
}
